/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/shared/ArraySerializationRouterBase.js"/>

(function(_) {
  var ns;

  ns = window.nspace("ccc.viz.shared.routers");

  ns.VizRouterBase = window.ccc.shared.ArraySerializationRouterBase.extend({
    initialize: function(options) {
      this.indicatorGroupId = options.indicatorGroupId;
      this.dispatcher = options.dispatcher;
      this.$tabs = $(options.tabsSelector);

      _.bindAll(this);
    },

    /**
     * The url parts to keep when constructing a default intertab url.
     */
    urlParts: function() {
      return {
        table: [
          this.selectorsModel.get("indicatorId"),
          this.selectorsModel.get("dataFormatId"),
          this.selectorsModel.get("timeFrameId")
        ],
        map: [
          this.selectorsModel.get("indicatorId"),
          "a", // characteristic
          "a", // location type
          this.selectorsModel.get("dataFormatId"),
          this.selectorsModel.get("timeFrameId")
        ],
        bar: [
          this.selectorsModel.get("indicatorId"),
          this.selectorsModel.get("characteristicId") == null
            ? "n"
            : this.selectorsModel.get("characteristicId"), //"n" default
          "n", // locations
          this.selectorsModel.get("dataFormatId"),
          this.selectorsModel.get("timeFrameId")
        ]
      };
    },

    updateLinks: function() {
      var self;

      self = this;

      // Table, map, and bar have slightly different options. Going between the visualizations we can retain
      // the selected indicator, data type, and timeframe.
      // Order matters.
      this.$tabs.each(function() {
        var $self, hash, href;

        $self = $(this);

        hash = self.urlParts()[$self.data("viztype")].join("/");
        href = $self.attr("href").split("#")[0] + "#" + hash;

        $self.attr("href", href);
      });
    },

    getValueOrDefault: function(val) {
      if (val == null) {
        return "a";
      }
      return val;
    },

    routeUrlParts: function() {
      throw "routeUrlParts needs to be implemented in subclasses.";
    },

    updateUrl: function() {
      var self = this;
      var urlParts = _.map(self.routeUrlParts(), function(urlPart) {
        return self.getValueOrDefault(urlPart);
      });

      self.navigate(urlParts.join("/"), { replace: true });
    },

    initializeModelListeners: function() {
      // Listen for changes to the selectors model and update our URL
      this.selectorsModel.on("change", this.updateUrl);
      this.selectorsModel.on("change", this.updateLinks);
    },

    completeRouterInitialization: function() {
      var self = this;

      this.initializeModelListeners();

      // For anything that might need to know when the views are finished with their initial render,
      // such as the server-side screenshot-taking code, wait for each view to signal that initial render is complete
      // then emit an event indicating that everything is finished
      var initialRenderPromises = _.map(
        _.filter(self.views, function(view) {
          return !!view.getInitialRenderPromise;
        }),
        function(view) {
          return view.getInitialRenderPromise();
        }
      );
      $.when.apply(this, initialRenderPromises).done(function() {
        self.dispatcher.trigger("initial-render-complete");
      });

      // Trigger a change notification on the model now that all of the selectors have finished initializing
      // so that other components can update themselves to reflect the current app state
      this.views.selectorsView.once("idle", function() {
        self.selectorsModel.trigger("change");
      });
    }
  });
})(_);
